module.exports = "/_next/static/images/txrp-4861b9585e6f41ee9e9ece2bff8ee907.svg";